import React, { useEffect, useState } from "react";
import { Table, Button, Tabs, message, Input, Modal } from "antd";
import { get, post, put } from "./../../api/axios";
import { Link } from "react-router-dom";
import { Pagination } from "antd";
import { checkPermission } from "../auth/ProtectedRoutes";
import {
  InstagramOutlined,
  PinterestOutlined,
  TwitterOutlined,
} from "@ant-design/icons";
import SearchBar from "../../utils/SearchBar";

const Properties = () => {
  const [filter, setFilter] = useState("published");
  const [data, setData] = useState([]);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedValue, setDebouncedValue] = useState(searchQuery);

  const [open, setOpen] = useState(false);
  const [openCommission, setOpenCommission] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [orderState, setOrder] = useState(0);
  const [commissionState, setCommission] = useState();
  const [code, setCode] = useState("");

  const updatePropertyStatus = (url, code, blockValue) => {
    setLoadingBtn(true);
    post(url, {
      code: code,
      block: blockValue,
      reason: "test",
      block_to: null,
    })
      .then((res) => {
        const updatedData = data?.filter((item) => item.code !== code);
        setData(updatedData);
        message.success("تم تغير الحالة بنجاح");
      })
      .catch((err) => {
        message.error("حدث خطأ ما!");
      })
      .finally(() => {
        setLoadingBtn(false);
      });
  };

  const handleStatus = (code) => {
    updatePropertyStatus("properties/publish", code, true);
  };

  const handleFetchLicense = (code) => {
    setLoadingBtn(true);

    post("properties/check-accommodation-license", { code: code })
      .then((res) => {
        // افحص إذا response.status أو response.data.status true
        if (res?.status === true) {
          message.success("تم التحقق بنجاح");

          // إعادة تحميل بيانات الجدول
          get(`properties?status=${filter}&search=${searchQuery}`).then(
            (res) => {
              setData(res?.data?.data);
            },
          );
        } else {
          message.error("البيانات غير صحيحة");
        }
      })
      .catch(() => {
        message.error("حدث خطأ أثناء جلب البيانات");
      })
      .finally(() => setLoadingBtn(false));
  };

  const handleStatusBlock = (code) => {
    updatePropertyStatus("properties/block", code, 0);
  };

  const showModal = (code, order) => {
    setCode(code);
    setOrder(order);
    setOpen(true);
  };

  const showCommissionModal = (code, commission) => {
    setCode(code);
    setCommission(commission);
    setOpenCommission(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleCancelCommission = () => {
    setOpenCommission(false);
  };

  const handleOk = () => {
    setConfirmLoading(true);
    post(`properties/order`, {
      code: code,
      order: orderState ? parseInt(orderState) : 0,
    })
      .then((res) => {
        if (res?.success === true) {
          message.success(res?.message);
          setOpen(false);
          setOrder(orderState);
          setCode("");

          // handlePagination(1); // إعادة تحميل الجدول
          setData((prev) =>
            prev.map((item) =>
              item.code === code
                ? { ...item, order: parseFloat(orderState) }
                : item,
            ),
          );
        } else {
          message.error(res?.message);
        }
      })
      .catch((err) => {
        message.error("حدث خطأ ما!");
      })
      .finally(() => {
        setConfirmLoading(false);
      });
  };

  const handleUpdateCommission = () => {
    setConfirmLoading(true);

    const payload = { code };

    if (
      commissionState !== undefined &&
      commissionState !== null &&
      commissionState !== ""
    ) {
      payload.commission = parseFloat(commissionState);
    }

    put("properties/update-commission", payload)
      .then((res) => {
        if (res?.success === true) {
          message.success(res?.message || "تم تعديل العمولة بنجاح");
          setOpenCommission(false);
          setCommission(commissionState);
          setCode("");
          //handlePagination(1); // إعادة تحميل الجدول
          setData((prev) =>
            prev.map((item) =>
              item.code === code
                ? { ...item, commission: parseFloat(commissionState) }
                : item,
            ),
          );
        } else {
          message.error(res?.message || "فشل تعديل العمولة");
        }
      })
      .catch((err) => {
        const backendMessage =
          err?.response?.data?.message ||
          err?.response?.data?.errors ||
          "حدث خطأ أثناء تعديل العمولة";

        message.error(backendMessage);
      })
      .finally(() => {
        setConfirmLoading(false);
      });
  };

  const columns = [
    {
      title: (
        <>
          رقم المضيف <br />
          الصورة <br />
          كود الوحدة <br />
        </>
      ),
      render: ({ id, image, owner }) => (
        <>
          {owner?.id ? `H${owner.id}` : "-"} <br />
          <img
            width={100}
            height={100}
            src={image}
            style={{ marginBottom: "5px" }}
            alt=""
          />{" "}
          <br />
          {id ? `U${id}` : "-"} <br />
        </>
      ),
    },
    {
      title: (
        <>
          أسم المضيف عربي <br />
          أسم المضيف إنجليزي <br />
          البريد الإلكتروني <br />
          الجوال <br />
          الجنسية <br />
          الإقامة <br />
          رقم الاثبات <br />
          الجنس
          <br />
          تاريخ الميلاد <br />
          العنوان <br />
        </>
      ),
      render: ({ owner }) => (
        <>
          {owner?.name || "-"} <br />
          {owner?.name_en || "-"} <br />
          {owner?.email || "-"} <br />
          {owner?.phone || "-"} <br />
          {/**  {owner?.id || "-"} <br /> */}
          {owner?.nationality?.name_ar || "-"} <br />
          {owner?.residence_type || "-"} <br />
          {owner?.id_number || "-"} <br />
          {owner?.gender || "-"} <br />
          {owner?.dob || "-"} <br />
          {owner?.address || "-"} <br />
        </>
      ),
    },
    {
      title: (
        <>
          نوع الوحدة <br />
          اسم الوحدة <br />
          {/* كود الوحدة <br /> */}
          المنطقة <br />
          المدينة <br />
          الحي \ القرية <br />
          {/* رابط جوجل ماب <br /> */}
          الأسم على جوجل ماب <br />
          الحد الادنى لايام الحجز <br />
          {/* تصنيف الوحدة <br /> */}
          الوحدة مناسبة لـ
          <br />
          ضيوف الوحدة
          <br />
          سياسة الإلغاء <br />
        </>
      ),
      render: ({
        name,
        type,
        google_commercial_name,
        total_rate,
        address_map,
        code,
        region,
        district,
        city,
        suitable_guests,
        image_insurance_cancellation,
        minimum_days,
        guests_type,
      }) => (
        <>
          {type || "-"} <br />
          {name || "-"} <br />
          {/* {code || "-"} <br /> */}
          {region || "-"} <br />
          {city || "-"} <br />
          {district || "-"} <br />
          {/* {address_map || "-"} <br /> */}
          {google_commercial_name || "-"} <br />
          {minimum_days || "-"} <br />
          {/* {total_rate.number || "-"} <br /> */}
          {Array.isArray(suitable_guests) && suitable_guests.length > 0
            ? suitable_guests.join(", ")
            : "-"}
          <br />
          {guests_type || "-"} <br />
          {image_insurance_cancellation?.cancellation_policy || "-"} <br />
        </>
      ),
    },
    {
      title: (
        <>
          نوع الملكية <br />
          السجل التجاري <br />
          اسم المنشاة
          <br />
          {/* نوعية الاستخدام <br /> */}
          {/* ضيوف الوحدة<br /> */}
          مبلغ التأمين <br />
          عدد الصور
          <br />
          اسم البنك <br />
          اسم صاحب الحساب <br />
          رقم الايبان <br />
          {/* سياسة الإلغاء <br /> */}
          التواصل اجتماعي
        </>
      ),
      render: ({
        is_commercial,
        commercial_record,
        commercial_record_name,
        rent_type,
        suitable_guests,
        images_count,
        image_insurance_cancellation,
        instagram_link,
        pinterest_link,
        twitter_link,
        bank_account,
        account_iban,
        account_name,
      }) => (
        <>
          {is_commercial ? "تجاري" : "شخصي"} <br />
          {commercial_record || "-"} <br />
          {commercial_record_name || "-"} <br />
          {/* {rent_type || "-"} <br /> */}
          {/* {suitable_guests.join("  ")}  <br />*/}
          {image_insurance_cancellation?.insurance_amount || "-"} <br />
          {images_count} <br />
          {bank_account && typeof bank_account === "object"
            ? bank_account.bank_name_ar || "-"
            : "-"}{" "}
          <br />
          {bank_account && typeof bank_account === "object"
            ? bank_account.account_name || "-"
            : "-"}{" "}
          <br />
          {bank_account && typeof bank_account === "object"
            ? bank_account.account_iban || "-"
            : "-"}{" "}
          <br />
          {/* {image_insurance_cancellation.receive_money} <br /> */}
          {/* {image_insurance_cancellation.cancellation_policy} <br /> */}
          <div className="d-inline-flex align-items-center">
            <a
              className="color-inherit text-decoration-none"
              target="_blank"
              rel="noreferrer"
              href={instagram_link}
            >
              <InstagramOutlined style={{ fontSize: "20px" }} />
            </a>

            <a
              className="color-inherit text-decoration-none"
              target="_blank"
              rel="noreferrer"
              href={twitter_link}
            >
              <TwitterOutlined style={{ fontSize: "20px" }} />
            </a>

            <a
              className="color-inherit text-decoration-none"
              target="_blank"
              rel="noreferrer"
              href={pinterest_link}
            >
              <PinterestOutlined style={{ fontSize: "20px" }} />
            </a>
          </div>
        </>
      ),
    },
    {
      title: (
        <>
          {/* <div> نوع مدة الاقامة </div> */}

          <div>تاريخ الحساب </div>
          <div>تاريخ النموذج </div>
          <div> تاريخ الاتفاقية</div>
          {filter === "published" ? (
            <>
              {" "}
              <div>تاريخ نشر الوحدة </div>
            </>
          ) : (
            ""
          )}
          <div> وقت الوصول </div>
          <div> وقت المغادرة </div>
          <div>الخميس</div>
          <div>الجمعة</div>
          <div>السبت</div>
          <div>وسط الأسبوع</div>

          {/* <div>رقم الموظف </div> */}
        </>
      ),
      render: ({
        arrive_leave,
        created_at,
        published,
        agreement_at,
        owner,
        status_logs,
        prices,
      }) => (
        <>
          {owner?.created_at || "-"}
          <br />
          {created_at || "-"}
          <br />
          {agreement_at?.split(" ")[0] || "-"}
          <br />
          {filter === "published" ? (
            <>
              {" "}
              {published?.published_at.split(" ")[0] || "-"}
              <br />
            </>
          ) : (
            ""
          )}

          {arrive_leave.map((item) => (
            <>
              {/* {item.type} <br /> */}
              {item.arrive_time || "-"} <br />
              {item.leave_time || "-"} <br />
            </>
          ))}
          {/* {published?.publisher_name} */}
          {prices?.thu?.length
            ? prices.thu.map((item, index) => (
                <div key={`thu-${index}`}>
                  {/* {item.type} <br /> */}
                  {item.price || "-"}
                </div>
              ))
            : "-"}

          {prices?.fri?.length
            ? prices.fri.map((item, index) => (
                <div key={`fri-${index}`}>
                  {/* {item.type} <br /> */}
                  {item.price || "-"}
                </div>
              ))
            : "-"}

          {prices?.sat?.length
            ? prices.sat.map((item, index) => (
                <div key={`sat-${index}`}>
                  {/* {item.type} <br /> */}
                  {item.price || "-"}
                </div>
              ))
            : "-"}

          {/* وسط الأسبوع */}
          {prices?.rest_of_week?.length
            ? prices.rest_of_week.map((item, index) => (
                <div key={`row-${index}`}>{item.price || "-"}</div>
              ))
            : "-"}
        </>
      ),
    },

    {
      title: (
        <>
          الحجوزات المؤكدة
          <br />
          الحجوزات الملغية
          <br />
          الحجوزات المنتهية
          <br />
          المزامنة
          <br />
          تغيير العمولة
          <br />
          عمولة الحجز
          <br />
          تغيير الترتيب
          <br />
          ترتيب الوحدة
          <br />
          {filter === "incomplete" ? "الخطوات" : "تغيير الحالة"}
          <br />
          حالة الوحدة
        </>
      ),
      render: ({ code, completed_steps, order, commission, reservations }) => (
        <>
          <div> {reservations?.confirmed}</div>
          <div> {reservations?.cancelled}</div>
          <div> {reservations?.ended}</div>
          <div>المزامنة</div>
          <button
            className="btn btn-primary py-1 mt-1"
            onClick={() => showCommissionModal(code, commission)}
          >
            تغيير العمولة{" "}
          </button>
          {/** يجب اضافة بوردر لللنتيجة */}

          <div>
            {commission !== null && commission !== undefined ? (
              <span className="commission-box">{commission}</span>
            ) : (
              "-"
            )}
          </div>

          <button
            className="btn btn-primary py-1 mt-2"
            onClick={() => showModal(code, order)}
          >
            تغيير الترتيب
          </button>
          <div>
            <span className="commission-box" style={{ marginBottom: "8px" }}>
              {order}
            </span>
          </div>

          {filter === "incomplete" ? (
            <>{completed_steps}</>
          ) : filter === "pending" ? (
            <button
              onClick={() => handleStatus(code)}
              disabled={loadingBtn}
              className="btn btn-warning py-0"
            >
              عرض الوحدة
            </button>
          ) : filter === "blocked" ? (
            <button
              onClick={() => handleStatusBlock(code)}
              disabled={loadingBtn}
              className="btn btn-success py-0"
            >
              اتاحة
            </button>
          ) : (
            <Link
              to={`/properties/change-status-properties/${code}`}
              className="btn btn-warning py-0"
            >
              إيقاف
            </Link>
          )}
          <br />
        </>
      ),
    },
    {
      title: (
        <>
          رقم ترخيص وزارة السياحة <br />
          رقم الهوية للترخيص <br />
          الترخيص المرفق <br />
          تحقق <br />
          مالك الترخيص (عربي) <br />
          مالك الترخيص (إنجليزي) <br />
          تاريخ إصدار الترخيص <br />
          تاريخ إنتهاء الترخيص <br />
          حالة الترخيص <br />
          لا يتطلب ترخيص <br />
        </>
      ),
      render: ({
        tourism_license_number,
        license_id_number,
        license_path,
        code,
        mt_owner_ar,
        mt_owner_en,
        mt_issue_date,
        mt_expiry_date,
        mt_status,
      }) => (
        <>
          {tourism_license_number || "-"}
          <br />
          {license_id_number || "-"}
          <br />
          {license_path ? (
            <a
              className="text-decoration-none"
              target="_blank"
              rel="noreferrer"
              href={license_path.replace("/licenses", "/storage/licenses")}
            >
              مشاهدة الترخيص المرفق
            </a>
          ) : (
            "-"
          )}
          <br />
          <br />
          <button
            className="btn btn-primary py-1"
            onClick={() => handleFetchLicense(code)}
          >
            التحقق
          </button>
          <br />
          {mt_owner_ar || "-"} <br />
          {mt_owner_en || "-"} <br />
          {mt_issue_date || "-"} <br />
          {mt_expiry_date || "-"} <br />
          {mt_status || "-"} <br />
        </>
      ),
    },
    // {
    //   title: (
    //     <>
    //       بيانات وزارة السياحة <br />
    //       (المالك - الإصدار - الانتهاء - الحالة)
    //     </>
    //   ),
    //   render: ({
    //     code,
    //     mt_owner_ar,
    //     mt_owner_en,
    //     mt_issue_date,
    //     mt_expiry_date,
    //     mt_status,
    //   }) => (
    //     <>
    //       <button
    //         className="btn btn-primary py-1"
    //         onClick={() => handleFetchLicense(code)}
    //       >
    //         التحقق
    //       </button>
    //       <br />
    //       <br />
    //       {mt_owner_ar || "-"} <br />
    //       {mt_owner_en || "-"} <br />
    //       {mt_issue_date || "-"} <br />
    //       {mt_expiry_date || "-"} <br />
    //       {mt_status || "-"} <br />
    //     </>
    //   ),
    // },
    // عمود جديد
    {
      title: (
        <>
          التقييم العام <br />
          نظافة المكان <br />
          حالة المكان <br />
          تطابق المواصفات <br />
          خدمة المضيف <br />
          الجودة مقابل السعر <br />
          عدد التقييمات <br />
          نقاط الوحدة <br />
          تصنيف الوحدة <br />
        </>
      ),
      render: ({ total_rate, average_ratings }) => (
        <>
          {average_ratings?.clean || "-"} <br />
          {average_ratings?.clean || "-"} <br />
          {average_ratings?.new || "-"} <br />
          {average_ratings?.matching || "-"} <br />
          {average_ratings?.service || "-"} <br />
          {average_ratings?.pricing || "-"} <br />
          {average_ratings?.total_rating || "-"} <br />
          {average_ratings?.total_count || "-"} <br />
          {total_rate.number || "-"} <br />
        </>
      ),
    },
  ];

  if (filter === "blocked") {
    const blockedColumn = {
      title: (
        <>
          <div>تاريخ الايقاف</div>
          <div>السبب</div>
          <div>تاريخ الاتاحة</div>
        </>
      ),
      dataIndex: "status_logs",
      render: (status_logs) => (
        <>
          {status_logs && status_logs.length > 0 ? (
            status_logs.map((item, index) => (
              <div key={index}>
                {item.created_at || "N/A"}
                <br />
                {item.reason || "N/A"}
                <br />
                {item.block_to || "N/A"}
                <br />
              </div>
            ))
          ) : (
            <div>لا توجد بيانات</div>
          )}
        </>
      ),
    };
    columns.splice(5, 0, blockedColumn);
  }

  const [loading, setLoading] = useState(true);

  const [total, setTotal] = useState(1);

  useEffect(() => {
    get(`properties?status=${filter}&search=${searchQuery}`).then((res) => {
      setData(res?.data.data);
      //console.log(searchQuery);

      setTotal(res?.data.meta.last_page);
      setLoading(false);
    });
  }, [debouncedValue]);
  const handlePagination = (pageNumber) => {
    setLoading(true);

    get(
      `properties?page=${pageNumber}&status=${filter}&search=${searchQuery}`,
    ).then((res) => {
      setData(res?.data.data);
      setTotal(res?.data.meta.last_page);
      setLoading(false);
    });
  };

  const onChangeTabs = (key) => {
    setFilter(key);
    setLoading(true);

    get(`properties?status=${key}`).then((res) => {
      setData(res?.data.data);
      setTotal(res?.data.meta?.last_page);
      setLoading(false);
    });
  };

  const items = [
    {
      key: "published",
      label: "معروضة",
    },
    {
      key: "pending",
      label: "غير معروضة",
    },
    {
      key: "incomplete",
      label: "غير مكتملة",
    },
    {
      key: "blocked",
      label: "موقوفة  ",
    },
  ];

  return (
    <>
      <div>
        <div className="row">
          {checkPermission("create-property") && (
            <div className="col-lg-4 offset-lg-4 mb-3">
              <Link
                className="text-decoration-none d-block h-100"
                to="/add-property/step-1"
              >
                <Button type="primary" block>
                  {" "}
                  إضافة{" "}
                </Button>
              </Link>
            </div>
          )}
          <SearchBar
            setSearchQuery={setSearchQuery}
            searchQuery={searchQuery}
            debouncedValue={debouncedValue}
            setDebouncedValue={setDebouncedValue}
          />

          <div className="col-12 grid-margin stretch-card tabs-section">
            <Tabs
              size="large"
              defaultActiveKey="agreed"
              items={items}
              onChange={onChangeTabs}
            />
            <div className="w-100">
              <Table
                locale={{ emptyText: "لا يوجد عناصر" }}
                loading={loading}
                pagination={false}
                bordered
                scroll={{
                  x: 1550,
                  y: "65vh",
                }}
                columns={columns}
                dataSource={data}
                size="middle"
              />
              <Pagination
                defaultCurrent={1}
                className="mt-4 d-flex align-items-center justify-content-center"
                position="bottomCenter"
                total={total * 10}
                onChange={handlePagination}
              />
              {/* <div className='text-center mt-3 btn-delete-table'>
                <Button type="primary" danger  size='large' >
                  حذف
                </Button>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <Modal
        title="تعديل ترتيب الوحدة"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        okText="حفظ"
        cancelText="إلغاء"
      >
        <Input
          type="number"
          value={orderState}
          onChange={(e) => setOrder(e.target.value)}
          placeholder="أدخل الترتيب الجديد"
        />
      </Modal>

      <Modal
        title="تعديل العمولة"
        open={openCommission}
        onOk={handleUpdateCommission}
        confirmLoading={confirmLoading}
        onCancel={handleCancelCommission}
        okText="حفظ"
        cancelText="إلغاء"
      >
        <Input
          type="number"
          value={commissionState}
          onChange={(e) => setCommission(e.target.value)}
          placeholder="أدخل العمولة"
        />
      </Modal>
    </>
  );
};

export default Properties;
